import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
function Row({
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx(RowStyled, {
    ...props,
    children
  });
}
const RowStyled = styled.div.withConfig({
  displayName: "RowStyled",
  componentId: "sc-13oau0l-0"
})(["display:grid;grid-template-columns:repeat(auto-fit,minmax(10px,1fr));gap:", ";"], token.spacing4);
export {
  Row
};
//# sourceMappingURL=Row.js.map
